(() => {
	function init() {
		$('[data-parallax]').each(function() {
			var $this = $(this);

			$this.jarallax({
				speed: 0.5,
				imgElement: '[data-parallax-img]',
				disableParallax: function() {
					if (/iPad|iPhone|iPod|Android|Trident/.test(navigator.userAgent) || $WINDOW.outerWidth() < 992) {
						var $image = $this.find('[data-parallax-img]');

						if ($image.is('picture')) {
							$image = $this.find('[data-parallax-img] img');
						}

						var imageSrc = $image.attr('src');

						if (imageSrc == null || imageSrc == undefined) {
							imageSrc = $image.attr('data-src');
						}

						$this.css('background-image', 'url(' + imageSrc + ')');
						return true;
					}

					return false;
				},
				onInit: function() {
					$this.attr('data-parallax', 'active');
				}
			});
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		init();
	});
})();
